import { useParams } from 'react-router-dom';

import { DashboardFrame } from '@/components/Dashboards/DashboardFrame';

export default function DashboardView({
    published = false
}: {
    published?: boolean;
}) {
    const { id } = useParams();

    if (!id) {
        return (
            <div className="flex justify-center items-center h-screen">
                <p className="text-muted-foreground">No dashboard selected</p>
            </div>
        );
    }

    return (
        <div className="bg-background h-screen">
            <DashboardFrame
                key={id}
                dashboardId={id}
                viewOnly
                published={published}
            />
        </div>
    );
}
